import cfg from "./config.json";

export type LocationType = "principal" | "regional" | "punct-lucru";

export interface Location {
  name: string;
  address: string;
  phone: string;
  schedule: string;
  type: LocationType;
  county?: string;
}

export const COMPANY = cfg.company as {
  name: string;
  phone: string;
  email: string;
  address: string;
  cif: string;
  founded: number;
};

export const SOCIAL = cfg.social as {
  facebook: string;
  instagram: string;
  linkedin: string;
};

export const LOCATIONS: Location[] = (
  cfg.locations as Omit<Location, "id">[]
).map((loc, idx) => ({ ...loc, id: `locatie-${idx}` }));
